<template>
  <button class="gl-button" @click.prevent="handlerClick" :disabled="disabledCtr" :class="classStyle">
    <div class="gl-button-wrap" ref="Glbutton">
      <transition-group name="slide-fade" tag="ul" key="-123">
        <div class="backcolor-list" v-for="i in list" :key="i.key" :style="{ left: i.x, top: i.y }"></div>
      </transition-group>
    </div>
    <span class="text-wrap">
      <i class="el-icon-loading" v-if="loading"></i>
      <slot></slot>
    </span>
  </button>
</template>

<script>
import { theme } from '@/assets/styles/variables.scss'

export default {
  props: {
    color: {
      type: String,
      default: theme
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  },
  name: 'gl-button',
  data() {
    return {
      num: 0,
      list: [],
      glButton: this.$refs.Glbutton
    }
  },
  computed: {
    disabledCtr() {
      return this.disabled || this.loading
    },
    classStyle() {
      const disable = this.disabledCtr ? 'gl-disabled' : ''
      return `${disable} gl-button-${this.type}`
    }
  },
  methods: {
    handlerClick(e) {
      this.num++
      const parentPosition = this.$refs.Glbutton.getBoundingClientRect()
      const position = { x: e.x - parentPosition.x + 'px', y: e.y - parentPosition.y + 'px', key: this.num }
      this.list.push(position)
      setTimeout(() => {
        this.list.shift()
      }, 1000)
      this.$emit('click', e)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@keyframes radiusScale {
  0% {
    width: 0%;
    opacity: 1;
    height: 0;
  }
  70% {
    opacity: 0.5;
    height: 200px;
  }
  100% {
    width: 200%;
    opacity: 0;
    height: 200px;
  }
}
.gl-disabled {
  background: rgba(93, 81, 218, 0.5) !important;
  cursor: not-allowed !important;
  .gl-button-wrap {
    opacity: 0.6 !important;
  }
}

.gl-button {
  background: #fff;
  border: 1px solid #dcdfe6;
  padding: 10px 15px;
  color: #606266;
  display: inline-block;
  white-space: nowrap;
  font-size: 14px;
  outline: none;
  cursor: pointer;
  position: relative;
  border-radius: 3px;
  overflow: hidden;
  transition: opacity 0.3s;
  .el-icon-loading {
    font-size: 14px;
    margin-right: 10px;
    opacity: 0.9;
  }
  &:hover {
    opacity: 0.8;
  }
  .gl-button-wrap {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.117647), 0 1px 4px rgba(0, 0, 0, 0.117647);
    overflow: hidden;
    transition: all 0.3s;
    .backcolor-list {
      position: absolute;
      height: 200%;
      border-radius: 50px;
      overflow: hidden;
      transform: translate(-50%, -50%);
      background: rgba(255, 255, 255, 0.2);
      animation: radiusScale 1s;
    }
  }
}
.gl-button-default {
  border: 1px solid #dcdfe6;
  color: #606266;
}
.gl-button-primary {
  color: #fff;
  border: $theme;
  background: $theme;
}
.gl-button-danger {
  color: #fff;
  border: $danger;
  background: $danger;
}
</style>
